import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { Helmet } from "react-helmet";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";

class ErrorReportList extends React.Component {

    constructor() {
        super();
        this.state = {

        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.errorReports);
        this.props.ChangeCurrentMenuName("errorReports");
    }

    componentWillUnmount() {
        this.props.ClearErrorReport();
    }

    getBrowser(navigator) {
        let ua = JSON.parse(navigator).userAgent, tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return "IE " + (tem[1] || "");
        }
        if (M[1] === "Chrome") {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {return tem.slice(1).join(" ").replace("OPR", "Opera");}
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
        tem = ua.match(/version\/(\d+)/i);
        if (tem != null) {
            M.splice(1, 1, tem[1]);
        }
        return M.join(" ");
    }
    OnLoadClick(element) {
        this.props.history.push("/SuperAdmin/ErrorReport?id=" + element.id);
    }

    render() {

        return <>
            <Area
                helmet={strings.helmetErrorReports}
                title={strings.errorReports}
            >
                <PaginationList
                    onGetElements={this.props.GetErrorReports}
                    onSavePagination={() => {}}
                    myElements={this.props.superAdmin.errorReport.list}

                    tableElement={(element) => {
                        return [
                            {
                                colTitle: strings.sourceError,
                                colContent: element ? element.source : null,
                                onClick: !element ? null : () => this.OnLoadClick(element)
                            },
                            {
                                colTitle: strings.creatorError,
                                colContent: element && element.creator ? element.creator.email : null,
                                onClick: !element ? null : () => this.OnLoadClick(element)
                            },
                            {
                                colTitle: strings.dateError,
                                colContent: element && element.dateCreated ? new Date(element.dateCreated + "Z").toLocaleString() : null,
                                onClick: !element ? null : () => this.OnLoadClick(element)
                            },
                            {
                                colTitle: strings.statusError,
                                colContent: element ? element.status : null,
                                onClick: !element ? null : () => this.OnLoadClick(element)
                            }
                        ];
                    }}
                />
            </Area>
        </>
        ;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(ErrorReportList);
